import { compose } from "redux";
import { useDrop } from "react-dnd";
import { connect } from "react-redux";
import React, { useRef } from "react";
import { RootRef } from "@material-ui/core";

import { sortViewGroup } from "features/planner/planner.actions";

const DraggableViewGroupDropTarget = ({
  type,
  size,
  viewId,
  column,
  onDrop,
  children,
  dispatchSortViewGroup,
}) => {
  const ref = useRef(null);

  const [, drop] = useDrop({
    drop: onDrop,
    accept: type.toString(),
    hover(item, monitor) {
      if (!ref.current) return;

      if (item.viewColumn === column) return;

      const hoverBoundingRect = ref.current.getBoundingClientRect();

      const clientOffset = monitor.getClientOffset();

      if (item.viewColumn > column) {
        if (clientOffset.x > hoverBoundingRect.right) {
          return;
        }
      }

      if (item.viewColumn < column) {
        if (clientOffset.x < hoverBoundingRect.left) {
          return;
        }
      }

      dispatchSortViewGroup({
        viewId,
        groupType: type,
        sourceIndex: item.viewColumnOrder,
        targetIndex: size,
        targetViewColumn: column,
        sourceViewColumn: item.viewColumn,
        sourceViewGroupId: item.viewGroupId,
      });

      item.viewColumn = column;
      item.viewColumnOrder = size;
    },
  });

  return <RootRef rootRef={drop(ref)}>{children}</RootRef>;
};
export default compose(
  connect(null, {
    dispatchSortViewGroup: sortViewGroup,
  }),
  React.memo,
)(DraggableViewGroupDropTarget);
